import { render } from "./Index-heatAlarmSetting.vue?vue&type=template&id=1006eb91&scoped=true"
import script from "./Index-heatAlarmSetting.vue?vue&type=script&lang=js"
export * from "./Index-heatAlarmSetting.vue?vue&type=script&lang=js"

import "./Index-heatAlarmSetting.vue?vue&type=style&index=0&id=1006eb91&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1006eb91"]])

export default __exports__